<template>
    <div class="msg" v-show="isShow">
        <div class="user-mes-box">
            <div class="user-mes-title"></div>
            <div class="dialog-content" v-text="dialogs"></div>
            <div class="user-mes-btn">
                <button type="button" v-text="lan['K024_Confirm']"></button>
            </div>
        </div>
    </div>
</template>
<script>
import dialog from '../assets/js/dialog'
export default {
    name:'Dialog',
    props:['lan','dialogs'],
    data(){
        return{
            
        }
    },
    computed:{
        isShow:function(){
            return dialog.isShow
        }
    },
    methods:{
        close:function(){
            this.$emit('close');
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
        text-align: center;
    }
    .user-mes-box{
        max-width:400px;
        min-width: 200px;
        display: inline-block;
    }
    .user-mes-title{
        height:24px;
    }
    .dialog-content{
        /* text-align: center; */
        word-wrap: break-word;
        padding:10px;
        box-sizing: border-box;
    }
    .user-mes-btn{
        text-align: center;
        padding-bottom:10px;
        box-sizing:border-box;
    }
    .user-mes-btn button{
        width: 80px;
        height:30px;
        background-color: #eff2f9;
        box-sizing: border-box;
        border: 1px solid #364860;
        outline: none;
    }

</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue